import { render, staticRenderFns } from "./HostedWaitingListForm.vue?vue&type=template&id=700c885a&"
import script from "./HostedWaitingListForm.vue?vue&type=script&lang=js&"
export * from "./HostedWaitingListForm.vue?vue&type=script&lang=js&"
import style0 from "./HostedWaitingListForm.vue?vue&type=style&index=0&id=700c885a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports